import { DataFetchingClientProvider } from 'data-fetching-client';
import { client } from './SetupGuideDataFetchingClient';
import { jsx as _jsx } from "react/jsx-runtime";
const SetupGuideDataFetchingClientProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: client,
    children: children
  });
};
export default SetupGuideDataFetchingClientProvider;